module.exports = __webpack_public_path__ + "static/media/solutions-grid-1.3d432f78.webp";